import { SubKategoriService } from '../service';
import { GENSET_SUB_KATEGORI_CONSTANT } from './GENSET_SUB_KATEGORI_CONSTANT';

const subKategoriService = new SubKategoriService();

export const GENSET_SUB_KATEGORI_ACTIONS = {
  get: (_query) => {
    return async (dispatch) => {
      dispatch({
        type: GENSET_SUB_KATEGORI_CONSTANT.GET_SUBKATEGORI_START,
        payload: {
          status_GET: 'LOADING',
        },
      });
      try {
        const data = await subKategoriService.getAll(_query);
        dispatch({
          type: GENSET_SUB_KATEGORI_CONSTANT.GET_SUBKATEGORI_SUCCESS,
          payload: {
            status_GET: 'SUCCESS',
            list: data?.results,
            message: data.message,
            properties: data.meta,
          },
        });
      } catch (error) {
        dispatch({
          type: GENSET_SUB_KATEGORI_CONSTANT.GET_SUBKATEGORI_FAILED,
          payload: {
            status_GET: 'FAILED',
            message: error.response.data.message,
          },
        });
      }
    };
  },
};
